module.exports = __webpack_public_path__ + "img/1506616132.1b8adb97.jpg";